import { isDefined } from "@clipboard-health/util-ts";

import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import { useInHomeCaseHistoryDataContext } from "../ShiftDiscovery/useInHomeCaseHistoryDataContext";
import { CaseHistoryDetailsBottomSheet } from "./CaseHistoryDetails/BottomSheet";
import { IN_HOME_CASE_DETAILS_PATH, IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH } from "./paths";
import { VisitOccurrencesBottomSheet } from "./VisitOccurrences/BottomSheet";

export function CaseHistoryModalRoutes() {
  const { caseHistoryData, baseNavigationPath } = useInHomeCaseHistoryDataContext();
  return (
    <ModalTransitionSwitch>
      <ModalRoute
        exact
        path={`${baseNavigationPath}/${IN_HOME_CASE_DETAILS_PATH}`}
        render={({ modalState }) => {
          if (!isDefined(caseHistoryData)) {
            return null;
          }

          return (
            <CaseHistoryDetailsBottomSheet
              modalState={modalState}
              caseHistoryData={caseHistoryData}
            />
          );
        }}
      />

      <ModalRoute
        path={`${baseNavigationPath}/${IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH}`}
        render={({ modalState }) => {
          return <VisitOccurrencesBottomSheet modalState={modalState} />;
        }}
      />
    </ModalTransitionSwitch>
  );
}
